const EMPTY_HISTORY = [];

function parseToolContent(content) {
  if (!content) return null;
  try {
    const parsed = JSON.parse(content);
    if (parsed?.data?.length) return parsed;
    return null;
  } catch (e) {
    return null;
  }
}

export const selectResultsHistory = (state) => {
  const messages = state?.dashboard?.aiSidebar?.messages;
  if (!Array.isArray(messages) || messages.length === 0) return EMPTY_HISTORY;

  const history = [];
  let lastUserQuestion = null;

  for (let i = 0; i < messages.length; i++) {
    const msg = messages[i];
    if (msg.type === "user") {
      lastUserQuestion = msg.content;
      continue;
    }
    if (msg.type !== "ai" || !msg.id || !Array.isArray(msg.steps)) continue;

    // Walk steps backwards to find the most recent "tool" step with data
    let toolPayload = null;
    for (let s = msg.steps.length - 1; s >= 0; s--) {
      const step = msg.steps[s];
      if (step?.type !== "tool") continue;
      const parsed = parseToolContent(step.content);
      if (parsed) {
        toolPayload = parsed;
        break;
      }
    }

    if (!toolPayload) continue;

    history.push({
      messageId: msg.id,
      messageIndex: i,
      question: lastUserQuestion,
      data: toolPayload.data,
      meta: toolPayload.meta,
      timestamp: msg.timestamp,
    });
  }

  return history.length > 0 ? history : EMPTY_HISTORY;
};

export const selectActiveResult = (state) => {
  const history = selectResultsHistory(state);
  if (history.length === 0) return null;

  const activeId = state?.dashboard?.aiSidebar?.activeResultMessageId ?? null;
  if (activeId) {
    const match = history.find((h) => h.messageId === activeId);
    if (match) return match;
  }
  return history[history.length - 1];
};

export const selectActiveResultIndex = (state) => {
  const history = selectResultsHistory(state);
  if (history.length === 0) return -1;

  const activeId = state?.dashboard?.aiSidebar?.activeResultMessageId ?? null;
  if (activeId) {
    const idx = history.findIndex((h) => h.messageId === activeId);
    if (idx >= 0) return idx;
  }
  return history.length - 1;
};
